import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import Tables from "../../../components/Tables";
import { formatDataVmailMytel, getDateChangeTime } from "../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../helper/const";
import FilterTimeDate from "../../components/FilterTimeDate";
import { formatDataVmailUnitelNtmDetail } from "../../../../helper/helper";
import styled from "styled-components";

export default function Details({ handleGetData, tabActive }) {
  const [date, setDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
    useSelector((state) => state.reducerVmUnitel?.data) || {};
  const { data: vm_mytel } = result;

  useEffect(() => {
    if (tabActive !== "2") return;
    handleGetData(date, date);
  }, [date, tabActive]);

  const columns = useMemo(() => {
    if (vm_mytel) {
      const data = formatDataVmailMytel(vm_mytel[date]);   
      return data;
    }
  }, [vm_mytel, date]);
  return (
    <Container>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTimeDate date={date} setDate={setDate} />
      </div>
      <Tables
        columns={columns}
        title="Overview statistic table"
        isHiddenPagination={false}
      />
    </Container>
  );
}

const Container = styled.div`
  .panel-sortable {
    tr:last-child {
      td {
        font-weight: 600;
      }
    }
  }
`;
